import { NgModule } from '@angular/core';

import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './../core/security/auth.guard';
import {StandardPageComponent} from '@app/core/comp/standard-page/standard-page.component';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/dashboard/main',
    },
    {
        path: '',
        component: StandardPageComponent,
        children: [
            {
                path     : 'user/profile',
                loadChildren: () => import('./common/user-profile/user-profile.module').then(m => m.UserProfileModule),
                canActivate: [AuthGuard]
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ]
})
export class ViewsModule { }
